/**
 * Lightweight visit tracker.
 * Posts to /api/diagnostics/track on every route change.
 * Fire-and-forget; failures are silent.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VisitTracker() {
  const location = useLocation();

  useEffect(() => {
    // Skip admin / api / static-asset paths
    const path = location.pathname;
    if (path.startsWith("/admin")) return;
    const t0 = Date.now();
    const onUnload = () => {
      try {
        const duration = Date.now() - t0;
        const body = JSON.stringify({
          path,
          referrer: document.referrer || null,
          user_agent: navigator.userAgent,
          duration_ms: duration,
        });
        if (navigator.sendBeacon) {
          const blob = new Blob([body], { type: "application/json" });
          navigator.sendBeacon(`${API}/diagnostics/track`, blob);
        } else {
          axios.post(`${API}/diagnostics/track`, JSON.parse(body)).catch(() => {});
        }
      } catch {}
    };
    // Immediate track (so we still log even if user closes quickly)
    axios.post(`${API}/diagnostics/track`, {
      path,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
    }).catch(() => {});
    window.addEventListener("beforeunload", onUnload);
    return () => window.removeEventListener("beforeunload", onUnload);
  }, [location.pathname]);

  return null;
}
